export const manifest = {
  screens: {
    scr_rh022r: { name: "Home", route: "/" },
  },
}
